export const CHROME = 'chrome';
export const EDGE = 'microsoftedge';
export const ELECTRON = 'electron latest';
export const FIREFOX = 'firefox';
export const INTERNET_EXPLORER = 'internet explorer';
export const MOBILE = 'mobile';
export const OPERA = 'opera';
export const PW_CHROMIUM = 'pw-chromium';
export const PW_FIREFOX = 'pw-firefox';
export const PW_WEBKIT = 'pw-webkit';
export const WEBKIT = 'webkit';
export const SAFARI = 'safari';
export const YANDEX = 'yandex';
